import { useEffect, useState } from 'react'

/**
 * Is de pagina voorbij een deel van het eerste scherm gescrold? `fraction` = deel van de
 * schermhoogte (0,6 = 60%). Hooguit één meting per beeld; geeft alleen een nieuwe waarde als
 * de stand omslaat.
 */
export function useScrolledPast(fraction: number) {
  const [past, setPast] = useState(false)

  useEffect(() => {
    let frame = 0
    const measure = () => {
      frame = 0
      setPast(window.scrollY > window.innerHeight * fraction)
    }
    const onScroll = () => {
      if (!frame) frame = window.requestAnimationFrame(measure)
    }
    measure()
    window.addEventListener('scroll', onScroll, { passive: true })
    window.addEventListener('resize', onScroll)
    return () => {
      window.removeEventListener('scroll', onScroll)
      window.removeEventListener('resize', onScroll)
      if (frame) window.cancelAnimationFrame(frame)
    }
  }, [fraction])

  return past
}
